import { lijuAudioPath } from "../../audio/liju-audio-paths.js";
import type { VoiceGender } from "../../audio/voices.js";
import type { ItemWriting } from "./yufa-written-item.js";
import { recordOf } from "./yufa-writing-read.js";

/** Both reviewed voices are bound to their bytes and the question's given sentence. */
export interface ListeningPrompt {
  readonly slug: string;
  readonly sha256: Readonly<Record<VoiceGender, string>>;
  readonly expected: ItemWriting;
  readonly access: "account";
}

/** Read only library recordings whose expected text agrees in both scripts. */
export function listeningPromptOf(
  value: unknown,
  given: ItemWriting | undefined,
): ListeningPrompt | undefined {
  const record = recordOf(value);
  const expected = recordOf(record?.["expected"]);
  const sha256 = recordOf(record?.["sha256"]);
  if (
    record === undefined ||
    given === undefined ||
    expected?.["simplified"] !== given.simplified ||
    expected?.["traditional"] !== given.traditional ||
    typeof record["slug"] !== "string" ||
    !/^[\p{Script=Han}a-zA-Z0-9-]+$/u.test(record["slug"]) ||
    typeof sha256?.["female"] !== "string" ||
    !/^[a-f0-9]{64}$/u.test(sha256["female"]) ||
    typeof sha256["male"] !== "string" ||
    !/^[a-f0-9]{64}$/u.test(sha256["male"]) ||
    record["access"] !== "account"
  ) {
    return undefined;
  }
  return {
    slug: record["slug"],
    sha256: { female: sha256["female"], male: sha256["male"] },
    expected: given,
    access: "account",
  };
}

/** Keep the lookup shared with ordinary sentence playback. */
export function listeningAddress(
  prompt: ListeningPrompt,
  voice: VoiceGender,
): string {
  return lijuAudioPath({ slug: prompt.slug, voice });
}
